module.exports = __webpack_public_path__ + "img/bell-bg.659ac9da.svg";